import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import OnboardingTutorial from "@/components/OnboardingTutorial";

export default function ProtectedRoute({ children, requireGroup = false }) {
  const { user, loading } = useAuth();
  const [tutorialOpen, setTutorialOpen] = useState(false);
  const [autoTriggered, setAutoTriggered] = useState(false);

  // Auto-show tutorial on first ever access (per logged-in user)
  useEffect(() => {
    if (user && !user.tutorial_completed && !autoTriggered) {
      setTutorialOpen(true);
      setAutoTriggered(true);
    }
  }, [user, autoTriggered]);

  // Listen for manual reopen requests (e.g. from Profile page)
  useEffect(() => {
    const handler = () => setTutorialOpen(true);
    window.addEventListener("hopzigo:open-tutorial", handler);
    return () => window.removeEventListener("hopzigo:open-tutorial", handler);
  }, []);

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <div className="brut-card px-6 py-4 font-heading text-lg">Caricamento…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireGroup && !user.active_group_id && !user.group_id) return <Navigate to="/onboarding" replace />;
  return (
    <>
      {children}
      {tutorialOpen && <OnboardingTutorial onClose={() => setTutorialOpen(false)} />}
    </>
  );
}
